<template>
  <section class="policy-form">
    <lazy-dom>
      <el-form
        ref="form"
        :rules="formRules"
        :model="formData">
        <div class="box form-half">
          <h3>Policy Detail</h3>
          <div class="form-item">
            <span>{{ isEndorsement? 'Endorsement Effective Date': 'Expected Effective Date' }}</span>
            <el-form-item
              v-if="isCancel"
              ref="pcy_expry_dt"
              :prop="checkRefer===1?'':'pcy_expry_dt'">
              <v-date-picker
                v-model="formData.pcy_expry_dt"
                :disabled="showBuyable"
                :_45daysComfirm='true'
                :picker-options="pickerOptions"/>
            </el-form-item>
            <el-form-item
              v-else
              ref="pcy_cmnt_dt"
              :prop="checkRefer===2?'pcy_cmnt_dt':''">
              <v-date-picker
                v-model="formData.pcy_cmnt_dt"
                :disabled="showBuyable"
                :_45daysComfirm='true'
                :picker-options="pickerOptions"/>
            </el-form-item>
          </div>
        </div>
        <div class="form-item form-half">
          <span>Expected Expiry Date</span>
          <el-form-item
          >
            <v-input
              :value="endDate"
              disabled
            />
          </el-form-item>
        </div>
        <div
          v-if="isRefer&&insuredItems.length>0"
          class="box width-700">
          <h3>Insured Items</h3>
          <div class="form-item">
            <v-checkbox-group
              v-model="formData.benefits"
              :disabled="showBuyable"
              :isColumn="false"
              :list="insuredItems" />
          </div>
        </div>
        <div
          v-if="benefitList.length>0&&!isRefer"
          class="box form-half">
          <!--          <h2>Insured Items</h2>-->
          <div
            class="form-item">
            <span>Insured Items</span>
            <el-form-item
            >
              <v-checkbox-group
                v-model="formData.benefits"
                :list="benefitList"
                :isColumn="false"
                :disabled="showBuyable"
                @change="handlerExtra"
              />
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
          <span>Type of Building </span>
          <el-form-item
            ref="bldg_typ"
            prop="bldg_typ">
            <v-select
              v-model="formData.bldg_typ"
              :list="localAllOptions.bldg_types"
              :disabled="isCancel||showBuyable"/>
          </el-form-item>
        </div>
        <div class="form-item">
          <span>Gross Floor Area (Indoor & Outdoor)</span>
          <el-form-item
            ref="floor_area"
            prop="floor_area">
            <v-input
              v-model="formData.floor_area"
              maxlength="8"
              :disabled="isCancel||showBuyable||checkDisabled('floor_area')"/>
          </el-form-item>
        </div>
        <div class="form-item">
          <span>Coverage</span>
          <el-form-item
            ref="coverage"
            prop="coverage">
            <v-select
              v-model="formData.coverage_id"
              :list="localAllOptions.coverage" />
          </el-form-item>
        </div>
        <div
          v-if="hasSumBuildingStructure"
          class="form-item">
          <span>Sum Insured of Building Structure</span>
          <el-form-item
            ref="bsc_sum_insured"
            prop="bsc_sum_insured">
            <v-input
              v-model="formData.bsc_sum_insured"
              :int="true"
              :keyNumber="true"
              prepend="HK$" />
          </el-form-item>
        </div>
        <mortgagee-form
          v-if="hasSumBuildingStructure"
          ref="mortgagee-form"
          :company-id="form.company_id"
          :mortgagorList="localAllOptions.mortgagor"
          :form='mortgageeForm'
          @getFormData="getSubFormData"></mortgagee-form>
        <div class="form-item">
          <span>Property Age</span>
          <el-form-item
            ref="prop_age"
            prop="prop_age">
            <v-select
              v-model="formData.prop_age"
              :list="localAllOptions.prop_age"
              :disabled="isCancel||showBuyable"/>
          </el-form-item>
        </div>
        <div class="form-item">
          <span>Occupancy</span>
          <el-form-item
            ref="prop_insured"
            prop="prop_insured">
            <v-select
              v-model="formData.prop_insured"
              :list="localAllOptions.prop_insured"
              :disabled="isCancel||showBuyable"/>
          </el-form-item>
        </div>
        <div class="form-item">
          <span>Does the flat have a roof/garden/balcony/workspace or on the lower floor (1st to 3rd floor)?</span>
          <el-form-item
            ref="has_roof"
            prop="has_roof">
            <v-radio-group
              v-model="formData.has_roof"
              :border="true"
              :disabled="showBuyable"
              :list="localAllOptions.has_roof" />
          </el-form-item>
        </div>
        <div class="form-item">
          <span>Is your Location of Risk same as Correspondence Address?</span>
          <el-form-item
            ref="is_same_as_corr_addr"
            prop="is_same_as_corr_addr">
            <v-radio-group
              v-model="formData.is_same_as_corr_addr"
              :border="true"
              :disabled="showBuyable"
              :list="yesNoOptions" />
          </el-form-item>
        </div>
        <template v-if="formData.is_same_as_corr_addr == 0">
          <span class="title">Location of Risk</span>
          <address-form
            ref="address-form"
            :formDataLock="formDataLock"
            :isRequired="isRequired"
            :form="insuredAddressForm"
            :formType="1"
            :not-valid="checkRefer===2?false:true"
            :disabled="isCancel||showBuyable"
            @getFormData="getSubFormData" />
        </template>
        <!--      </div>-->

        <div class="box">
          <h3>Policyholder Details</h3>
          <homefire-policy-holder-form
            ref="policy-holder-form"
            :formDataLock="formDataLock"
            :form="formData"
            :disabled="isCancel||showBuyable"
            :isRequired="isRequired"
            :checkRefer="checkRefer"
            is-home
            @getFormData="getSubFormData"
            @confirm="getConfirmChangeResult"/>
        </div>

        <div
          v-if="false"
          class="box">
          <h3>Coverage</h3>

          <div class="form-item">
            <span>Building Structure Coverage Sum Insured</span>
            <el-form-item
              prop="bsc_sum_insured">
              <!--            <v-input-->
              <!--              v-model="formData.bsc_sum_insured"-->
              <!--              :disabled="formData.type==10||editType==1||editType==2||isCancel"-->
              <!--              append="HKD"-->
              <!--            />-->
              <v-input
                v-model="formData.bsc_sum_insured"
                append="HKD"
              />
            </el-form-item>
          </div>

          <span class="title">Section 1 – Household Contents “All Risks”</span>
          <!-- <div class="form-item">
          <span>Mobile Phone 1 Model declaration</span>
          <v-input v-model="formData.phone_mdl_1" />
        </div>
        <div class="form-item">
          <span>Mobile Phone 2 Model declaration</span>
          <v-input v-model="formData.phone_mdl_2" />
        </div> -->
          <span class="title">Owner's Liability</span>
          <div
            class="form-item">
            <span>Sum Insured of Owner's Liability</span>
            <el-form-item>
              <v-select
                v-model="formData.sum_owner_liability"
                :list="localAllOptions.owner_liability" />
            </el-form-item>
          </div>
        <!-- <div class="form-item">
          <span>Owner's Liability</span>
          <el-form-item
            prop="owner_liability_ind">
            <v-radio-group
              v-model="formData.owner_liability_ind"
              :border="true"
              :list="yesNoOptions" />
          </el-form-item>
        </div>
        <div
          v-if="formData.owner_liability_ind == 1"
          class="form-item">
          <span>Sum Insured of Owner's Liability</span>
          <el-form-item
            prop="sum_owner_liability">
            <v-select
              v-model="formData.sum_owner_liability"
              :list="localAllOptions.owner_liability" />
          </el-form-item>
        </div> -->
        </div>

        <div
          v-if="hasBenefitsTab"
          class="box">
          <h3 id="dom-benefits">More Benefits Detail</h3>
          <el-form
            ref="benefitsForm"
            :rules="rules"
            :disabled="showBuyable"
            :model="benefitsForm">
            <template v-if="hasBenefitsEmployees">
              <span class="benefits-label">Domestic Helper Information</span>
              <div class="drivers-container">
                <div
                  v-for="(item, index) in benefitsForm.domestic_helper_info"
                  :key="index"
                  class="card"
                >
                  <div class="driver-switch">
                    <v-switch
                      v-model="item.open" />
                  </div>
                  <!-- disabled 遮罩 -->
                  <div
                    v-if="!item.open"
                    class="mask"></div>
                  <span class="title">Domestic Helper {{ index+1 }}</span>

                  <div class="form-item">
                    <span>Name</span>
                    <el-form-item
                      :ref="`domestic_helper_info.${index}.name`"
                      :rules="rules.name"
                      :prop="`domestic_helper_info.` + index + '.name'">
                      <v-input
                        v-model="item.name" />
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <span>Nationality</span>
                    <el-form-item
                      :ref="`domestic_helper_info.${index}.nationality`"
                      :rules="rules.nationality"
                      :prop="`domestic_helper_info.` + index + '.nationality'">
                      <v-select
                        v-model="item.nationality"
                        :list="localAllOptions.nationality"/>
                    </el-form-item>

                  </div>
                  <div class="form-item">
                    <span>Date of Birth</span>
                    <el-form-item
                      :ref="`domestic_helper_info.${index}.dob`"
                      :rules="rules.dob"
                      :prop="`domestic_helper_info.` + index + '.dob'">
                      <v-birth-day v-model="item.dob" />
                    </el-form-item>

                  </div>
                  <div class="form-item">
                    <span></span>
                    <!--                    <el-form-item-->
                    <!--                      :ref="`domestic_helper_info.${index}.id_type`"-->
                    <!--                      :rules="rules.id_type"-->
                    <!--                      :prop="`domestic_helper_info.` + index + '.id_type'">-->

                    <!--                    </el-form-item>-->
                    <v-radio-group
                      v-model="item.id_type"
                      :list="personalIdTypOptions"
                    />
                  </div>
                  <!--          <v-radio-group-->
                  <!--            v-model="formData.id_type"-->
                  <!--            :list="personalIdTypOptions"-->
                  <!--            class="mg-b-10" />-->
                  <div class="form-item">
                    <!--                    <span>HKID / Passport Number</span>-->
                    <el-form-item
                      :ref="`domestic_helper_info.${index}.id_no`"
                      :rules="rules.id_no"
                      :prop="`domestic_helper_info.` + index + '.id_no'">
                      <v-input
                        v-model="item.id_no"
                        :placeholder="item.id_type==1?'A123456(3), please input A1234563':''"
                      />
                    </el-form-item>

                  </div>
                  <!--                  <div class="form-item">-->
                  <!--                    <span>HKID / Passport </span>-->
                  <!--                    <el-form-item-->
                  <!--                      :ref="`domestic_helper_info.${index}.id_type_pic`"-->
                  <!--                      :rules="rules.id_type_pic"-->
                  <!--                      :prop="`domestic_helper_info.` + index + '.id_type_pic'">-->
                  <!--                      <file-container-->
                  <!--                        :edit="true"-->
                  <!--                        :fileData="item.id_type_pic"-->
                  <!--                        :otherData="{-->
                  <!--                          type: 'employees',-->
                  <!--                          index-->
                  <!--                        }"-->
                  <!--                        @delete="handlerDeleteFile"-->
                  <!--                        @uploadSuccess="handlerUploadSuccess" />-->
                  <!--                    </el-form-item>-->

                  <!--                </div>-->
                </div>
              </div>
            </template>
            <template v-if="hasBenefitsPets">
              <span class="benefits-label">Pet Information</span>
              <div class="drivers-container">
                <div
                  v-for="(item, index) in benefitsForm.pet_info"
                  :key="index"
                  class="card"
                >
                  <div class="driver-switch">
                    <v-switch
                      v-model="item.open" />
                  </div>
                  <!-- disabled 遮罩 -->
                  <div
                    v-if="!item.open"
                    class="mask"></div>
                  <span class="title">Pet {{ index+1 }}</span>

                  <div class="form-item">
                    <span>Type of Pet</span>
                    <el-form-item
                      :ref="`pet_info.${index}.type_of_pet`"
                      :rules="rules.type_of_pet"
                      :prop="`pet_info.` + index + '.type_of_pet'">
                      <v-select
                        v-model="item.type_of_pet"
                        :list="localAllOptions.type_of_pet" />
                    </el-form-item>

                  </div>
                  <div class="form-item">
                    <span>Pet Name</span>
                    <el-form-item
                      :ref="`pet_info.${index}.name`"
                      :rules="rules.name"
                      :prop="`pet_info.` + index + '.name'">
                      <v-input
                        v-model="item.name"
                        uppercase/>
                    </el-form-item>

                  </div>
                  <div class="form-item">
                    <span>Year of Birth</span>
                    <el-form-item
                      :ref="`pet_info.${index}.dob`"
                      :rules="rules.dob"
                      :prop="`pet_info.` + index + '.dob'">
                      <v-select
                        v-model="item.dob"
                        :list="dobOptions" />
                    </el-form-item>

                  </div>
                  <div class="form-item">
                    <span>Microchip No.</span>
                    <el-form-item
                      :ref="`pet_info.${index}.microchip_no`"
                      :rules="rules.microchip_no"
                      :prop="`pet_info.` + index + '.microchip_no'">
                      <v-input
                        v-model="item.microchip_no"
                        uppercase/>
                    </el-form-item>

                  </div>
                  <!--                  <div class="form-item">-->
                  <!--                    <span>Microchip Copy</span>-->
                  <!--                    <el-form-item-->
                  <!--                      :ref="`pet_info.${index}.microchip_copy_pic`"-->
                  <!--                      :rules="rules.microchip_copy_pic"-->
                  <!--                      :prop="`pet_info.` + index + '.microchip_copy_pic'">-->
                  <!--                      <file-container-->
                  <!--                        :edit="true"-->
                  <!--                        :fileData="item.microchip_copy_pic"-->
                  <!--                        :otherData="{-->
                  <!--                          type: 'pet',-->
                  <!--                          index-->
                  <!--                        }"-->
                  <!--                        @delete="handlerDeleteFile"-->
                  <!--                        @uploadSuccess="handlerUploadSuccess" />-->
                  <!--                    </el-form-item>-->
                  <!--                -->
                  <!--                  </div>-->
                </div>
              </div>
            </template>
            <template v-if="hasBenefitsPhone">
              <span class="benefits-label">Accidental Damage to Mobile Phone</span>
              <div class="form-item">
                <span>Mobile Phone Model Name 1</span>
                <el-form-item
                  ref="phone_mdl_1"
                  prop="phone_mdl_1">
                  <v-input
                    v-model="benefitsForm.phone_mdl_1"
                    :disabled="showBuyable"/>
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Mobile Phone Model Name 2</span>
                <el-form-item
                  ref="phone_mdl_2"
                  prop="phone_mdl_2">
                  <v-input
                    v-model="benefitsForm.phone_mdl_2"
                    :disabled="showBuyable"/>
                </el-form-item>
              </div>
            </template>
          </el-form>

        </div>


        <div class="box">
          <h2>Upload Document</h2>
          <div class="flex-sb">
            <div
              v-if="editType==3"
              class="form-item form-half">
              <span >Renewal Letter（Insurer）</span>
              <el-form-item
                ref="renewal_letter_insurer_path_id"
                prop="renewal_letter_insurer_path_id">
                <v-upload
                  :card="true"
                  ::disabled="isCancel||showBuyable"
                  :fileData="formData.renewal_letter_insurer"
                  :otherData="{
                    target: 'renewal_letter_insurer',
                    idKey: 'renewal_letter_insurer_path_id',
                    nameKey: 'renewal_letter_insurer_path',
                    type:'renewal_letter_insurer_path'
                  }"
                  @delete="handlerUploadDelete"
                  @uploadSuccess="handlerUploadSuccess" />
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span  v-if="formData.cust_typ == 2">Certificate of Incorporation/Business Registration Certificate</span>
              <span v-else>Policyholder HKID</span>
              <el-form-item
                ref="id_type_pic_path_id"
                prop="id_type_pic_path_id">
                <v-upload
                  :card="true"
                  :fileData="formData.id_type_pic"
                  :file-list="fileList"
                  :otherData="{
                    target: 'id_type_pic',
                    idKey: 'id_type_pic_path_id',
                    nameKey: 'id_type_pic_path',
                    type:'id_type_pic_path'
                  }"
                  :disabled="isCancel||showBuyable||checkDisabled(['id_no','id_type'])"
                  @uploadSuccess="handlerUploadSuccess"
                  @delete="handlerUploadDelete"
                />
              </el-form-item>
            </div>
            <!--            <div-->
            <!--              v-if="formData.cust_typ == 2"-->
            <!--              class="form-item form-half">-->
            <!--              &lt;!&ndash;              <span>Certificate of Incorporation</span>&ndash;&gt;-->
            <!--              <span>Business Registration Certificate</span>-->
            <!--              <el-form-item-->
            <!--                ref="br_pic_path_id"-->
            <!--                prop="br_pic_path_id"-->
            <!--              >-->
            <!--                <v-upload-->
            <!--                  :card="true"-->
            <!--                  :fileData="formData.br_pic"-->
            <!--                  :otherData="{-->
            <!--                    target: 'br_pic',-->
            <!--                    idKey: 'br_pic_path_id',-->
            <!--                    nameKey: 'br_pic_path'-->
            <!--                  }"-->
            <!--                  :disabled="isCancel||showBuyable"-->
            <!--                  @uploadSuccess="handlerUploadSuccess"-->
            <!--                  @delete="handlerUploadDelete"-->
            <!--                />-->
            <!--              </el-form-item>-->
            <!--            </div>-->
          </div>
          <div
            v-if="hasBenefitsTab&&hasBenefitsEmployees"
            class="flex-pet">
            <div
              v-for="(item, index) in benefitsForm.domestic_helper_info"
              :key="'domestic_helper_info_'+index"
              class="form-item">
              <template v-if="item.open">
                <!-- <div
                v-if="!item.open"
                class="upload-mask"></div> -->
                <span >Domestic Helper {{index+1}} HKID / Passport </span>
                <el-form-item
                >
                  <!--                <file-container-->
                  <!--                  :edit="true"-->
                  <!--                  :fileData="item.id_type_pic"-->
                  <!--                  :otherData="{-->
                  <!--                    type: 'employees',-->
                  <!--                    index-->
                  <!--                  }"-->
                  <!--                  @delete="handlerDeleteFile"-->
                  <!--                  @uploadSuccess="handlerUploadSuccess" />-->
                  <v-upload
                    :card="true"
                    :fileData="item.id_type_pic"
                    :file-list="fileList"
                    :otherData="{
                      type: 'nm_domestic_id_type_pic',
                      index
                    }"
                    :disabled="isCancel || !item.open||showBuyable"
                    @uploadSuccess="handlerUploadSuccess"
                    @delete="handlerUploadDelete"
                  />
                </el-form-item>
              </template>
            </div>
          </div>
          <div
            v-if="hasBenefitsTab&&hasBenefitsPets"
            class="flex-pet">
            <div
              v-for="(item, index) in benefitsForm.pet_info"
              :key="'pet_info'+index"
              class="form-item form-half">
              <!-- <div
                v-if="!item.open"
                class="upload-mask"></div> -->
              <span >Pet {{index+1}} Microchip Copy </span>
              <el-form-item
              >
                <v-upload
                  :card="true"
                  :fileData="item.microchip_copy_pic"
                  :file-list="fileList"
                  :otherData="{
                    type: 'microchip_copy_pic',
                    index,
                  }"
                  :disabled="isCancel || !item.open||showBuyable"
                  @uploadSuccess="handlerUploadSuccess"
                  @delete="handlerUploadDelete"
                />
              </el-form-item>
            </div>
          </div>
          <div class="form-item">
            <span>Additional Documents</span>
            <file-container
              v-for="(item, index) in formData.other_file"
              :key="index"
              :fileData="item"
              :file-list="fileList"
              :otherData="{
                index,
                type: 'other_file'
              }"
              :edit="true"
              titleName= "Additional Documents"
              :disabled="isCancel||showBuyable"
              @delete="handlerDeleteFile"
              @uploadSuccess="handlerUploadSuccess"
            />

            <v-upload
              :file-list="fileList"
              :otherData="{
                type: 'other_file',
              }"
              :disabled="isCancel||showBuyable"
              @uploadSuccess="handlerUploadSuccess" />
          </div>
        </div>

      </el-form>
    </lazy-dom>
  </section>
</template>
<script>
import dayjs from 'dayjs'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import MixinRules from '@/mixins/rules'
import AddressForm from '@/views/components/address-form'
import HomefirePolicyHolderForm from '@/views/components/modules/homefire/homefire-policy-holder-form'
import {mapState} from 'vuex'
import { getExtraCompute} from '@/api/order'
import MortgageeForm from '@/views/components/mortgagee-form'
import MixinSame from '@/mixins/same'

export default {
  name: 'HomefirePolicyForm',
  components: {
    AddressForm,
    HomefirePolicyHolderForm,
    MortgageeForm
  },
  mixins: [MixinOptions, MixinFormat, MixinRules,MixinSame],
  props: {
    form: {
      type: Object,
      default: null
    },
    editType:{
      type:Number,
      default:0
    },
    checkRefer:{
      type:Number,
      default:0
    },
    isCancel: {
      type: Boolean,
      default: false
    },
    isEndorsement: {
      type: Boolean,
      default: false
    },
    showBuyable: {
      type: Boolean,
      default: false
    },
    isRefer: {
      type: Boolean,//refer case 显示insured item 全部选项
      default: false
    },
    isBenefitCoverage: {
      type: Boolean,//正常流程edit quote 勾选insured item 调用报价接口
      default: false
    },
    editQuote:{
      type: Boolean,
      default: false
    },
    formInitDataLock: {
      type: Number,
      default: 0
    },
  },
  data() {
    const employeesObj = {
      open: true,
      name: '',
      nationality: '',
      id_type: '',
      id_no: '',
      dob: '',
      id_type_pic: null
    }
    const petObj = {
      open: true,
      type_of_pet: '',
      name: '',
      dob: '',
      microchip_no: '',
      microchip_copy_pic: null
    }
    const checkOpen = (rule, value, callback) => {
      const index = rule.field.split('.')[1]
      const target = rule.field.split('.')[0]
      const { open } = this.benefitsForm[target][index]
      if(open) {
        const valueResult = value !== null && value !== ''
        if(!valueResult && this.checkRefer == 2) {
          callback(new Error(this.$t('placeholder.input')))
        }
      }
      callback()
    }
    const checkAreaNumber = (rule, value, callback) => {
      var reg = /^[1234567890]*$/
      if (value && !reg.test(value)) {
        callback( new Error( '最大輸入8位整數' ))
      } else {
        callback()
      }
    }
    return {
      employeesObj,
      petObj,
      pickerOptions: {
        disabledDate(time){
          return time.getTime()<Date.now()
        }
      },
      mortgageeForm: {},
      formData: {
        updDefInfo: [],
        disable_filed: [],
        benefit_coverage:null,
        class_id: '',
        pcy_cmnt_dt: '',
        pcy_expry_dt:'',
        bldg_typ: '',
        prop_age: '',
        prop_insured: '',
        // sum_insured: '',
        floor_area: '',
        // phone_mdl_1: '',
        // phone_mdl_2: '',
        // owner_liability_ind: '',
        // sum_owner_liability: '',
        is_same_as_corr_addr: '',
        insured_addr_room: '',
        insured_addr_floor: '',
        insured_addr_block: '',
        insured_addr_building: '',
        insured_addr_street: '',
        insured_addr_district: '',
        insured_addr_area: '',
        insured_addr_region: '',
        // Policyholder
        isrd_title: '',
        isrd_lst_nm: '',
        isrd_fst_nm: '',
        isrd_dob: '',
        occ_id: '',
        id_no: '',
        mobile_no: '',
        email: '',
        addr_room: '',
        addr_floor: '',
        addr_block: '',
        addr_building: '',
        addr_street: '',
        addr_district: '',
        addr_area: '',
        addr_region: '',
        // 公司
        isrd_com_nm: '',
        ci_no: '',
        phone_no: '',
        bsns_nature_id: '',
        contact_nm: '',
        contact_occ_id: '',
        contact_phone: '',
        contact_email: '',
        // file
        id_type_pic: null,
        id_type_pic_path: '',
        id_type_pic_path_id: '',
        br_pic:null,
        br_pic_path_id: '',
        br_pic_path: '',
        other_file: [],
        // 補充
        cust_typ: '',
        id_type: '',
        coverage_id: '',
        benefits: [],
        less_verify_save: 0 ,
        has_roof: 0 ,
        type:'',

        renewal_letter_insurer_path: '',
        renewal_letter_insurer_path_id: '',
        renewal_letter_insurer: {},
      },
      // benefits
      benefitsForm: {
        // domestic_helper_info: [
        //   {...employeesObj},
        //   {...employeesObj}
        // ],
        // pet_info: [
        //   {...petObj},
        //   {...petObj},
        //   {...petObj}
        // ],
        phone_mdl_1: '',
        phone_mdl_2: ''
      },
      formDataLock: 0,
      oldFormDataLock: -1,
      subForm: {
        'address-form': false,
        'policy-holder-form': false,
        'mortgagee-form': false
      },
      otherData: {},
      insuredAddressForm: {},
      formResult: {},
      extraRules: {
        // homefire benefit
        name: [
          { validator: checkOpen, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        nationality: [
          { validator: checkOpen, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        dob: [
          { validator: checkOpen, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        id_no: [
          { validator: checkOpen, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        id_type_pic: [
          { validator: checkOpen, message: this.$t('placeholder.upload'), trigger: ['blur'] }
        ],
        type_of_pet: [
          { validator: checkOpen, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        microchip_no: [
          { validator: checkOpen, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        microchip_copy_pic: [
          { validator: checkOpen, message: this.$t('placeholder.upload'), trigger: ['blur'] }
        ],
        floor_area: [
          { validator: checkAreaNumber, message: this.$t('placeholder.upload'), trigger: ['blur'] }
        ],
      }
    }
  },
  computed: {
    ...mapState('common', ['nationalityOptions']),
    hasSumBuildingStructure() {
      const { coverage_id } = this.formData
      if([2, 3].includes(coverage_id)) {
        return true
      }
      return false
    },
    orderId(){
      let {id=''} = this.form||{}
      return id
    },
    localAllOptions() {
      return this.allOptions26
    },
    insuredItems(){
      let {benefits=[]} = this.localAllOptions||{}
      return benefits||[]
    },
    formRules() {
      let rulesOption = JSON.stringify(this.rules)
      rulesOption = JSON.parse(rulesOption)
      const checkAreaNumber = (rule, value, callback) => {
        var reg = /^[1234567890]*$/
        if (value && !reg.test(value)) {
          callback( new Error( '最大輸入8位整數' ))
        } else {
          callback()
        }
      }
      Object.keys(rulesOption).some(keys => {
        rulesOption[keys][0].required = false
      })

      Object.keys(this.ruleRequestData).some(key => {
        // Object.keys(rulesOption).some(keys => {
        //   if(key==keys)
        rulesOption[key][0].required = true
        if(key=='floor_area'){
          rulesOption[key][0].validator =checkAreaNumber
          rulesOption[key][0].message = '最大輸入8位整數'
        }
        // })
      })
      return this.checkRefer ===2 ? this.rules : rulesOption
      // return this.rules
    },
    hasBenefitsTab() {
      // const { benefit_coverage = {} } = this.form
      const { benefits = [],benefit_coverage = {} } = this.formData
      let {domestic_helper,mobile_phone,pet} = benefit_coverage||{}
      // const { benefits = [] } = this.formData
      let result = false
      if(this.isRefer&&this.editType!=3){
        if(!benefits || benefits.length < 1) {
          return false
        }

        benefits.some(item => {
          if([1, 4, 8].includes(item)) {
            result = true
          }
        })

      }
      return domestic_helper||mobile_phone||pet||result
    },
    hasBenefitsEmployees() {
      // const { benefit_coverage ={} } = this.form
      const { benefits = [],benefit_coverage = {} } = this.formData
      const {domestic_helper=false} = benefit_coverage||{}
      // const { benefits = [] } = this.formData
      if(this.isRefer&&this.editType!=3) {
        if (benefits && benefits.includes(1)) {
          return true
        }
        return false
      }
      else
        return domestic_helper
    },
    hasBenefitsPets() {
      const { benefits = [],benefit_coverage ={} } = this.formData
      // const { benefit_coverage ={} } = this.form
      const {pet=false} = benefit_coverage||{}
      if(this.isRefer&&this.editType!=3) {
        if (benefits && benefits.includes(4)) {
          return true
        }
        return false
      }
      else
        return pet
    },
    hasBenefitsPhone() {
      // const { benefit_coverage ={} } = this.form
      const { benefits = [],benefit_coverage = {} } = this.formData
      const {mobile_phone=false} = benefit_coverage||{}
      return  false
      // const { benefits = [] } = this.formData
      if(this.isRefer&&this.editType!=3) {
        if (benefits && benefits.includes(8)) {
          return true
        }
        return false
      }
      return mobile_phone
    },
    endDate(){
      let date = ''
      let { pcy_expry_dt,pcy_cmnt_dt,pcy_period,ins_end_dt} = this.formData
      if(pcy_period==0)
        date = pcy_expry_dt
      else
        date=pcy_cmnt_dt? dayjs(pcy_cmnt_dt).add(pcy_period,'month').subtract(1,'day').format('YYYY-MM-DD'):''
      if(this.isEndorsement)
        date = ins_end_dt?ins_end_dt:pcy_expry_dt
      if(!this.isCancel)
        this.formData.pcy_expry_dt = date
      return dayjs(date).format('DD-MM-YYYY')
    },
    benefitList(){
      let {quote_coverage_list} =this.form||{}
      let {kyc_benefit=[]} = quote_coverage_list||{}
      let arr = []
      if(this.editQuote){
        let {benefits=[]} = this.allOptions26||{}
        arr = JSON.parse(JSON.stringify(benefits))
      }else{
        kyc_benefit.some(item=>{
          if(item.is_show!==0){
            arr.push({name:item.name,id:item.id})
          }
        })
      }
      return arr||[]
    },
    isFina(){
      let {merchant_platform} = this.form||{}
      return merchant_platform ==2
    },
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        if (this.formInitDataLock !== this.oldFormDataLock) {
          this.oldFormDataLock = this.formInitDataLock
          if (val) {
            // 接口過濾參數
            // let params = {}
            // Object.keys(this.formData).some(key => {
            //   if(key in val) {
            //     params[key] = val[key]
            //   }
            // })
            // let form = JSON.parse(JSON.stringify(this.formData))
            // Object.assign(
            //   form,
            //   params
            // )
            // if(form.id_type == 2) {
            //   // form.id_type = 1
            //   form.id_no = ''
            // }
            let form = JSON.parse(JSON.stringify(val))
            this.formDataLock += 1
            this.formData = form

            // benefit
            const {
              domestic_helper_info = [],
              pet_info = [],
              phone_mdl_1,
              phone_mdl_2,
              quote_coverage_list,
              benefits,
              no_of_pet
            } = val

            let {kyc_benefit = []} = quote_coverage_list || {}
            let arr = []
            kyc_benefit.some(item => {
              if (item.is_selected == 1)
                this.formData.benefits.push(item.id)
            })
            this.formData.benefits = [...new Set(this.formData.benefits)]
            let domesticHelperInfo = []
            for (let i = 0; i < 2; i++) {
              if (domestic_helper_info && domestic_helper_info.length > i) {
                domesticHelperInfo.push({
                  ...domestic_helper_info[i],
                  open: true
                })
              } else {
                domesticHelperInfo.push({
                  ...this.employeesObj,
                  open: false
                })
              }
            }
            if (domesticHelperInfo.length > 0)
              domesticHelperInfo[0].open = true

            let petInfo = []
            for (let i = 0; i < 3; i++) {
              if (pet_info && pet_info.length > i) {
                petInfo.push({
                  ...pet_info[i],
                  open: true
                })
              } else {
                petInfo.push({
                  ...this.petObj,
                  open: false
                })
              }
            }
            if (benefits && benefits.includes(4)) {
              if (no_of_pet == 0) {
                this.formData.no_of_pet = 1
                petInfo[0].open = true
              }
            }
            this.benefitsForm = {
              ...this.benefitsForm,
              domestic_helper_info: domesticHelperInfo,
              pet_info: petInfo,
              phone_mdl_1,
              phone_mdl_2
            }


            if (val.id_type_pic) {
              const {path, id} = val.id_type_pic
              this.formData.id_type_pic_path = path
              this.formData.id_type_pic_path_id = id
            }
            // if(val.cert_of_inc_pic) {
            //   const { path, id } = val.cert_of_inc_pic
            //   this.formData.cert_of_inc_pic_path = path
            //   this.formData.cert_of_inc_pic_path_id = id
            // }
            if (val.br_pic) {
              const {path, id} = val.br_pic
              this.formData.br_pic_path = path
              this.formData.br_pic_path_id = id
            }
            let date = new Date(this.formData.pcy_expry_dt).getTime()
            let dateCmnt = new Date(this.formData.pcy_cmnt_dt).getTime()

            if (date < Date.now()) {
              this.formData.pcy_expry_dt = ''
            }
            if (dateCmnt < Date.now() && this.editType != 3) {
              this.formData.pcy_cmnt_dt = ''
            }
            if (this.isCancel) {
              // this.formData.pcy_expry_dt =''
            }
            this.handler().handlerAddress(this.formData)
            this.handler().handlerMortgagee(this.formData)
          }
        }
      }
    },
    'form.benefit_coverage':{
      immediate:true,
      deep:true,
      handler(val){
        this.formData.benefit_coverage =val
      }
    },
    // formInitDataLock: {
    //   handler(val, old = -1) {
    //     if(val !== old) {
    //       this.oldFormDataLock = old
    //     }
    //   }
    // },
  },
  methods: {
    checkDisabled(field) {
      const { disable_filed = [] } = this.form
      if(typeof(field) != 'string'){
        let res = false
        field.map(item => {
          if(disable_filed.includes(item)){
            res = true
          }
        })
        return res
      }
      return disable_filed.includes(field)&&!!this.form[field]
    },
    handlerExtra(){
      let {extra_benefits,pcy_cmnt_dt,benefits} = this.formData
      let params = {
        extra_benefits,
        pcy_cmnt_dt,
        benefits
      }
      this.$emit('changeCompute',params)
      if(this.isBenefitCoverage)
      {
        params.order_id =this.orderId
        this.network().getExtraCompute(params)
      }
    },
    async submitForm(otherData = {}) {

      await this.$refs['form'].validate(async (valid, rules) => {
        if(valid) {
          this.otherData = otherData
          let subForm = this.subForm
          if(!this.hasSumBuildingStructure){
            delete subForm['mortgagee-form']
          }
          Object.keys(subForm).some(key => {
            this.subForm[key] = false
            if(key == 'address-form' && this.formData.is_same_as_corr_addr == 1) {
              this.subForm[key] = true
            }
            else {
              this.$refs[key].submitForm(key)
            }
          })
          if(Object.values(subForm).some(item => item === false)) {
            return
          }
          let {benefits=[]} = this.formData||{}
          const uniqueArray = benefits.filter((value, index, self) => {
            return self.indexOf(value) === index
          })
          this.formData.benefits = uniqueArray
          if(this.hasBenefitsTab) {
            // 檢查 benefits form
            await this.$refs['benefitsForm'].validate((valid, rules) => {
              if(valid) {
                let result = {
                  ...this.formData
                }
                const {
                  domestic_helper_info = [],
                  pet_info = [],
                  phone_mdl_1,
                  phone_mdl_2
                } = this.benefitsForm
                if(this.hasBenefitsEmployees) {
                  let domesticHelperInfo = domestic_helper_info.filter(item => item.open == true)
                  result.domestic_helper_info = domesticHelperInfo
                  result.no_of_domestic_helper = domesticHelperInfo.length
                }
                if(this.hasBenefitsPets) {
                  let petInfo = pet_info.filter(item => item.open == true)
                  result.pet_info = petInfo
                  result.no_of_pet = petInfo.length
                }
                if(this.hasBenefitsPhone) {
                  result = {
                    ...result,
                    phone_mdl_1,
                    phone_mdl_2
                  }
                }

                this.handlerSubmitResult(result, otherData)
              }
              else {
                this.scrollToDom(document.getElementById('dom-benefits'))
              }
            })
            return
          }

          this.handlerSubmitResult({ ...this.formData }, otherData)



          // const result = {
          //   ...this.formData,
          //   // id_type: this.formData.cust_typ == 2? 3: 1
          // }
          // // if(this.formData.owner_liability_ind != 1) {
          // //   delete result.sum_owner_liability
          // // }
          // this.formResult = result
          // const { updDefInfo } = result
          // if(updDefInfo && updDefInfo.length > 0) {
          //   // if(result.isUpdatePolicyData === 1) {
          //   this.$refs['policy-holder-form'].openConfirmDialog()
          // }
          // else {
          //   this.$emit('getFormData', result, otherData)
          // }
        }
        else {
          this.scrollToValidDom(rules)
        }
      })
    },
    handlerSubmitResult(result, otherData) {
      let params = result
      if(this.formData.is_same_as_corr_addr == 1) {
        const sameAddress = this.getSameInsuredAddress()
        params = {
          ...params,
          ...sameAddress
        }
      }
      this.formResult = params
      const { updDefInfo } = result
      if(updDefInfo && updDefInfo.length > 0&&!this.isFina) {
        this.$refs['policy-holder-form'].openConfirmDialog()
      }
      else {
        this.$emit('getFormData', {
          ...params,
          // benefits: [1] // todo 為了測試 refer
        }, otherData)
      }
    },
    getSameInsuredAddress() {
      const {
        addr_room,
        addr_floor,
        addr_block,
        addr_building,
        addr_street,
        addr_district,
        addr_area,
        addr_region
      } = this.formData
      return {
        insured_addr_room: addr_room,
        insured_addr_floor: addr_floor,
        insured_addr_block: addr_block,
        insured_addr_building: addr_building,
        insured_addr_street: addr_street,
        insured_addr_district: addr_district,
        insured_addr_area: addr_area,
        insured_addr_region: addr_region
      }
    },

    getSaveSubmitForm(otherData = {}){
      this.otherData = otherData
      let subForm = this.subForm
      if(!this.hasSumBuildingStructure){
        delete subForm['mortgagee-form']
      }
      Object.keys(subForm).some(key => {
        this.subForm[key] = false
        if(key == 'address-form' && this.formData.is_same_as_corr_addr == 1) {

        }
        else {
          this.$refs[key].submitFormNoVaild(key)
        }
      })
      // if(Object.values(this.subForm).some(item => item === false)) {
      //   return
      // }
      let {benefits=[]} = this.formData||{}
      const uniqueArray = benefits.filter((value, index, self) => {
        return self.indexOf(value) === index
      })
      if(this.formData.is_same_as_corr_addr == 1){
        this.handler().handlerAddressResult(this.formData)
      }
      const result = {
        ...this.formData,
        benefits:uniqueArray
        // id_type: this.formData.cust_typ == 2? 3: 1
      }
      // if(this.formData.owner_liability_ind != 1) {
      //   delete result.sum_owner_liability
      // }
      this.formResult = result
      const { updDefInfo } = result
      // if(updDefInfo && updDefInfo.length > 0) {
      //   // if(result.isUpdatePolicyData === 1) {
      //   this.$refs['policy-holder-form'].openConfirmDialog()
      // }
      // else {
      this.$emit('getFormData', result, otherData)
      // }

    },
    getConfirmChangeResult(result) {
      const params = this.formResult
      if(result) {
        params.upd_def_addr = 1 // 更新用戶資料
      }
      this.$emit('getFormData', params, this.otherData)
    },
    getSubFormData(formName, data) {
      this.subForm[formName] = true
      if(formName == 'address-form') {
        this.handler().handlerAddressResult(data)
      }
      else {
        Object.assign(this.formData, data)
      }
    },

    handlerUploadSuccess({ data, result, otherData }) {
      const { idKey, nameKey, target, index = '', type } = otherData
      const { id, path } = data
      if(type === 'nm_domestic_id_type_pic') {
        this.$set(this.benefitsForm.domestic_helper_info[index], 'id_type_pic', data)
        this.$refs['benefitsForm'].clearValidate(`domestic_helper_info.${index}.id_type_pic`)
      }
      else if(type === 'microchip_copy_pic') {
        this.$set(this.benefitsForm.pet_info[index], 'microchip_copy_pic', data)
        this.$refs['benefitsForm'].clearValidate(`pet_info.${index}.microchip_copy_pic`)
      }
      else if(type !== 'other_file') {
        this.$set(this.formData, idKey, id)
        this.$set(this.formData, nameKey, path)
        this.$set(this.formData, target, data)
        this.$refs['form'].validateField(idKey)
      }
      else {
        if(index === '') {
          this.formData.other_file.push(data)
        }
        else {
          this.$set(this.formData.other_file, index, data)
        }
      }
    },
    handlerUploadDelete({ otherData }) {
      const { idKey, nameKey, target, index = '', type } = otherData

      if(type === 'nm_domestic_id_type_pic') {
        this.$set(this.benefitsForm.domestic_helper_info[index], 'id_type_pic', null)
        this.$refs['benefitsForm'].clearValidate(`domestic_helper_info.${index}.id_type_pic`)
      }
      else if(type === 'microchip_copy_pic') {
        this.$set(this.benefitsForm.pet_info[index], 'microchip_copy_pic', null)
        this.$refs['benefitsForm'].clearValidate(`pet_info.${index}.microchip_copy_pic`)
      }
      else if(type !== 'other') {
        this.$set(this.formData, idKey, '')
        this.$set(this.formData, nameKey, '')
        this.$set(this.formData, target, null)
        this.$refs['form'].validateField(idKey)
      }
    },
    handlerDeleteFile(otherData) {
      const { type, index } = otherData
      if(type === 'other_file') {
        this.formData.other_file.splice(index, 1)
      }
      else if(type === 'employees') {
        this.$set(this.benefitsForm.domestic_helper_info[index], 'id_type_pic', null)
      }
      else if(type === 'pet') {
        this.$set(this.benefitsForm.pet_info[index], 'microchip_copy_pic', null)
      }
    },
    handler() {
      return {
        handlerMortgagee: (data) =>{
          const {
            post_ind,
            post_nm_id,
            post_nm_other,
            post_addr
          } = data
          const obj = {
            post_ind,
            post_nm_id,
            post_nm_other,
            post_addr
          }
          this.mortgageeForm = JSON.parse(JSON.stringify(obj))
        },
        handlerAddress: (data) => {
          const {
            insured_addr_room,
            insured_addr_floor,
            insured_addr_block,
            insured_addr_building,
            insured_addr_street,
            insured_addr_district,
            insured_addr_area,
            insured_addr_region
          } = data
          const obj = {
            addr_room: insured_addr_room,
            addr_floor: insured_addr_floor,
            addr_block: insured_addr_block,
            addr_building: insured_addr_building,
            addr_street: insured_addr_street,
            addr_district: insured_addr_district,
            addr_area: insured_addr_area,
            addr_region: insured_addr_region,
          }

          this.insuredAddressForm = JSON.parse(JSON.stringify(obj))
        },
        handlerAddressResult: data => {
          const {
            addr_room,
            addr_floor,
            addr_block,
            addr_building,
            addr_street,
            addr_district,
            addr_area,
            addr_region
          } = data
          const params = {
            insured_addr_room: addr_room,
            insured_addr_floor: addr_floor,
            insured_addr_block: addr_block,
            insured_addr_building: addr_building,
            insured_addr_street: addr_street,
            insured_addr_district: addr_district,
            insured_addr_area: addr_area,
            insured_addr_region: addr_region
          }
          Object.assign(this.formData, params)
        }
      }
    },
    network(){
      return{
        getExtraCompute: async params => {
          const {data} = await getExtraCompute(params)
          let {benefit_coverage} = data
          this.formData.benefit_coverage = benefit_coverage
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.policy-form {
  .title {
    font-size: 20px;
    color: #616266;
    font-weight: 500;
  }
  .benefits-label {
    display: block;
    padding-bottom: 10px;
    font-size: 20px;
    color: #616266;
  }
  .drivers-container {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .title {
        display: block;
        padding-bottom: 15px;
        color: #616266;
        font-size: 20px;
        font-weight: 500;
      }
      .card {
        position: relative;
        margin-bottom: 15px;
        width: calc(50% - 10px);
        .driver-switch {
          position: absolute;
          top: 15px;
          right: 15px;
        }
        .mask {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          top: 50px;
          z-index: 2;
          background: rgba(255, 255, 255, 0.7);
        }
      }
    }
  .flex-pet{
    display: flex;
    flex-wrap: wrap;
    .form-item{
      flex: 1;
    }
  }
  .upload-mask {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top:0;
    z-index: 2;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 5px;
    padding: 10px;
  }
}
</style>
